import { render, staticRenderFns } from "./Section5.vue?vue&type=template&id=a87cc3a2&scoped=true&"
import script from "./Section5.vue?vue&type=script&lang=js&"
export * from "./Section5.vue?vue&type=script&lang=js&"
import style0 from "./Section5.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Section5.vue?vue&type=style&index=1&id=a87cc3a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a87cc3a2",
  null
  
)

export default component.exports